<template>
  <basic-container>
    <el-form
      :model="searchForm"
      ref="searchFormRef"
      label-width="100px"
      label-suffix=":"
      v-show="searchBoxFlag"
    >
      <el-row :gutter="24">

        <el-col :span="6">
          <el-form-item label="项目名称" prop="projectId">
            <el-select
              v-model="searchForm.projectId"
              style="width: 100%"
              placeholder="项目名称"
              @change="projectIdChange"
            >
              <el-option
                v-for="item in projectIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>




        <el-col :span="6">

          <el-form-item label="用户" prop="accountName">
            <el-input
              clearable
               :disabled="model==='view'" v-model="searchForm.accountName"
              placeholder="用户"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-col>




        <!-- <el-col :span="6">

          <el-form-item label="负责人" prop="contactName">
            <el-input
              clearable
               :disabled="model==='view'" v-model="searchForm.contactName"
              placeholder="负责人"
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-col> -->




        <el-col :span="24">
          <div style="float: right">
            <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
              搜索
            </el-button>
            <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      ref="crud"
      @on-load="onLoad"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @selection-change="selectionChange"
    >
      <template slot="menuRight">
        <searchFromShow
          :searchBoxFlag.sync="searchBoxFlag"
          :removeHeight="searchHeight"
          :option="option"
          reduceHeight="20"
          :refOption="$refs.crud"
        ></searchFromShow>
      </template>

      <!-- <template slot="menuLeft">
        <el-button
        type="primary" size="small" @click="addNursingForm"> 新 增</el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button type="text" size="small" @click="viewRecord(scope.row)">查看 </el-button>
        <el-button type="text" size="small" @click="editRecord(scope.row)">编辑 </el-button>

        <el-button type="text" size="small" @click="deleteFun(scope.row.id)">删除 </el-button>

      </template> -->
    </avue-crud>

    <itemList ref="itemList"></itemList>
    <hr-dialog
      :title="formModel==='add'?'新增':formModel==='edit'?'编辑':'查看'"
      :allowFull="false"
      width="60%"
      :visible.sync="nursingFormVisible"
    >
      <template slot="body">
        <braceletForm
          :model="formModel"
          :row="formRow"
          @cancle="recordCancle"
          v-if="nursingFormVisible"
          @success="recordSuccess"
          :projectId="this.searchForm.projectId"
        ></braceletForm>
      </template>
    </hr-dialog>





    <hr-dialog
      :title="'服务管理'"
      :allowFull="false"
      width="60%"
      :visible.sync="serveManageVisible"
    >
      <template slot="body">
        <serviceForm
          :model="formModel"
          :row="formRow"
          @cancle="recordCancle"
          v-if="serveManageVisible"
          @success="recordSuccess"
          :projectId="this.searchForm.projectId"
        ></serviceForm>
      </template>
    </hr-dialog>



  </basic-container>
</template>
  <script>
import { getProjectList } from '@/api/crmedical/project/project';
import { stockWarnPage, getWarehouseList, stockWarnDelete, getProviderUserList } from '../api/serveItemManage.js';
// import braceletForm from './braceletForm.vue';
// import serviceForm from './serviceForm.vue';
import { getDictionary } from '@/api/common.js';
import searchFromShow from '@/components/search-form-show/index';
import { mapGetters } from 'vuex';
import { getScoreListPage,getCommunityListPage,getProviderList, submitServiceInfo, getServiceProviderPage, getNursinghome, getWristbandPage, getDeviceTypeList, wristbandRemove,removeServiceCommunity, deviceStart, deviceStop } from '../api/serveItemManage';
export default {
  // components: { serviceForm, braceletForm },
  data() {
    return {
      serveManageVisible: false,
      editVisible: false,
      formModel: 'add',
      isImportDialogShow: false,
      settingTotalWarnVisible: false,
      nursingFormVisible: false,
      printVisible: false,
      addOrderVisible: false,
      alarmRuleVisible: false,
      alarmRuleTittle: '编辑',
      alarmRuleModel: 'view',
      rowInfo: {},
      searchForm: {
        projectId: '',
        nursinghomeId: '',
        warehouseId: '',
        type: "",
        consumableCode: '',
        consumableName: '',
        specification: '',
        upWarnFlag: 'false',
        downWarnFlag: 'false',
      },
statusList:[
        {
          dictKey: '0',
          dictValue: '禁用',
        },
        {
          dictKey: '1',
          dictValue: '启用',
        }],
      projectList: [],

      provideList: [
        {
          dickey: '0',
          dicvalue: '购买',
        },
        {
          dickey: '1',
          dicvalue: '免费',
        },
      ],
      option: {
        selection: false,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: '类型',
            prop: 'type',
            dicUrl: '/api/blade-system/dict/dictionary?code=out_order_service_integral_flow_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '发放积分',
            prop: 'score',
          },
          {
            label: '用户',
            prop: 'accountName',
          },
          {
            label: '备注',
            prop: 'remark',
          },
          {
            label: '操作时间',
            prop: 'createTime',
          },

          // {
          //   label: '服务小区类型',
          //   prop: 'type',
          //   dicUrl: '/api/blade-system/dict/dictionary?code=out_order_service_community_type',
          //   props: {
          //     label: 'dictValue',
          //     value: 'dictKey',
          //   },
          // },
          // {
          //   label: '联系人姓名',
          //   prop: 'contactName',
          // },
          // {
          //   label: '联系人电话',
          //   prop: 'contactPhone',
          // },
          // {
          //   label: '住址',
          //   prop: 'address',
          // },
          // {
          //   label: '描述',
          //   prop: 'description',
          // },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      searchBoxFlag: true,
      searchHeight: '',
      selectionList: [],
      recordIds: [],
      canteenList: [],
      warehouseList: [],
      selectionIds: '',
      formRow: {},
      nursinghomeIdList: [],
      deviceTypeIdList:[],
      onlineStatusList:[],
      deviceStatuseList:[],
      projectIdList:[],
      provideTypeList:[],
      moduleTypeList:[],
      providerList:[],
    };
  },
  created() {
    this.initData();
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        switchBtn: this.vaildData(this.permission.bracelet_switch, false),
        viewBtn: this.vaildData(this.permission.deviceManage_view, false),
        addBtn: this.vaildData(this.permission.deviceManage_add, false),
        editBtn: this.vaildData(this.permission.deviceManage_edit, false),
        delBtn: this.vaildData(this.permission.deviceManage_del, false),
      };
    },
  },
  mounted() {
    this.calcHeight();
  },
  methods: {
    projectIdChange(id){

      getProviderList({projectId:this.searchForm.projectId,status:'1'}).then(res=>{
        this.providerList = res.data;
      });
    },
    serveFun(row){
      this.formRow = row;
      this.formModel = 'edit';
      this.serveManageVisible = true;
      this.editVisible = true;
    },
    switchFun(id,status){
      if(status==1){
        deviceStart({id:id}).then(res=>{
          this.$message.success('操作成功！');
          this.onLoad();
        })
      }

      if(status==2){
        deviceStop({id:id}).then(res=>{
          this.$message.success('操作成功！');
          this.onLoad();
        })
      }

    },
    openItemDetail(row) {
      this.$refs.itemList.openItemListOnload(row.id, row.name);
    },
    addNursingForm() {
      this.formRow = {projectId:this.searchForm.projectId};
      this.formModel = 'add';
      this.nursingFormVisible = true;
    },
    importSuccess() {
      this.isImportDialogShow = false;
      this.onLoad();
    },

    deleteFun(id) {
      this.$confirm(' 是否删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          removeServiceCommunity(id).then((re) => {
            this.$message.success('删除成功');
            this.onLoad();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },

    editRecord(row) {
      this.formRow = row;
      this.formModel = 'edit';
      this.nursingFormVisible = true;
      this.editVisible = true;
    },
    settingTotalWarn() {
      this.formModel = 'add';
      this.settingTotalWarnVisible = true;
    },
    importFun() {
      this.isImportDialogShow = true;
    },
    nursingForm() {
      this.formModel = 'add';
      this.nursingFormVisible = true;
    },

    recordCancle() {
      this.serveManageVisible = false;
      this.editVisible = false;
      this.nursingFormVisible = false;
      this.settingTotalWarnVisible = false;
    },
    recordSuccess() {
      this.serveManageVisible = false;
      this.editVisible = false;
      this.nursingFormVisible = false;
      this.settingTotalWarnVisible = false;
      this.onLoad();
    },
    viewRecord(row) {
      this.formRow = row;
      this.formModel = 'view';
      this.nursingFormVisible = true;
      this.editVisible = true;
    },

    addRecord() {
      this.alarmRuleTittle = '新增';
      this.alarmRuleVisible = true;
      this.rowInfo = {
        projectId: this.searchForm.projectId,
      };
      this.alarmRuleModel = 'add';
    },

    stopCanteen() {
      this.alarmRuleVisible = true;
    },
    // nursinghomeIdChange(nursinghomeId) {


    //       getDeviceTypeList({id: nursinghomeId}).then((res)=>{
    //         this.deviceTypeIdList = res.data;
    //       });
    //   // this.searchForm.warehouseId = '';

    //   // this.warehouseList = [];
    //   // getWarehouseList({ nursinghomeId: this.searchForm.nursinghomeId }).then((res) => {
    //   //   this.warehouseList = res.data;
    //   // });
    //   // //  getCanteenName({nursinghomeId:nursinghomeId}).then(res=>{
    //   // //           this.canteenList = res.data
    //   // //        })
    //   // this.getDeptList(this.searchForm.nursinghomeId);
    //   // this.getCanteen(this.searchForm.nursinghomeId);
    // },
    searchRecord() {
      this.page.currentPage = 1;
      if (this.searchForm.upWarnFlag == '') {
        this.searchForm.upWarnFlag = false;
      }
      if (this.searchForm.downWarnFlag == '') {
        this.searchForm.downWarnFlag = false;
      }
      this.onLoad();
    },
    searchClear() {
      this.tool.clearObject(this.searchForm, 'nursinghomeId');
      this.searchForm.type = '0';
    },

    calcHeight() {
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - this.searchHeight - 279 - 20;
    },
    initData() {

      getProjectList().then(res=>{
        this.projectIdList = res.data;
        this.searchForm.projectId = res.data[0].id;

      getProviderList({projectId:this.searchForm.projectId,status:'1'}).then(res=>{
        this.providerList = res.data;
      });
        this.onLoad();
      })
      // getNursinghome().then((res) => {
      //   this.nursinghomeIdList = res.data;
      //   if (this.nursinghomeIdList.length > 0) {
      //     this.$set(this.searchForm, 'nursinghomeId', this.nursinghomeIdList[0].id);
      //     // getWarehouseList({ nursinghomeId: this.searchForm.nursinghomeId }).then((res) => {
      //     //   this.warehouseList = res.data;
      //     // });

      //     getDeviceTypeList({id: this.searchForm.nursinghomeId}).then((res)=>{
      //       this.deviceTypeIdList = res.data;
      //     });
      //     this.onLoad();
      //   }
      // });
      // getDictionary('nursinghome_online_status_type').then((res) => {
      //   this.onlineStatusList = res.data;
      // });
      // getDictionary('nursinghome_device_statuse_type').then((res) => {
      //   this.deviceStatuseList = res.data;
      // });
      // getDictionary('nursinghome_release_mode_type').then((res) => {
      //   this.provideList = res.data;
      // });
      // getDictionary('out_order_service_provider_type').then((res) => {
      //   this.provideTypeList = res.data;
      // });
      // getDictionary('out_order_module_type').then((res) => {
      //   this.moduleTypeList = res.data;
      // });
    },

    onLoad() {
      if (this.searchForm.projectId != '') {
        this.loading = true;

        getScoreListPage(
          Object.assign(
            {},
            { current: this.page.currentPage, size: this.page.pageSize },
            this.searchForm
          )
        )
          .then(({ data }) => {
            this.data = data.records;
            this.data.forEach(ele => {
              ele.type = ele.type+'';
            });
            this.page.total = data.total;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>

  <style scoped>
::v-deep .avue-crud__right {
  display: flex;
}
/deep/ .el-drawer__body {
  overflow: scroll !important;
}
::v-deep .avue-crud .el-form-item {
  display: block;
}

.money {
  text-align: right;
}
.txtOver {
  display: -webkit-box;
  overflow: hidden; /*超出隐藏*/
  text-overflow: ellipsis; /*隐藏后添加省略号*/
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
  <style>
#alarmRule > div > div.el-dialog__body {
  height: calc(100% - 100px);
}
</style>
